import { createContext, useContext } from 'react';
import { ButtonProps } from '../button.types';

export type ButtonGroupContextValue = Pick<
  ButtonProps,
  'size' | 'mode' | 'variant' | 'disabled' | 'pending'
>;

export const ButtonGroupContext = createContext<ButtonGroupContextValue | null>(
  null
);

export const useButtonGroup = () => useContext(ButtonGroupContext);
